import { Component, CustomElement } from "../../core/CustomElement";

// Interfaces
import Discussion from "../../core/interfaces/Discussion";

// Components to use.
import "../discussion-list/discussionList";
import "../forms/button";
import "../forms/input-text";
import CCCDiscussionList from "../discussion-list/discussionList";
import { CCCButton } from "../forms/button";
import { CCCInputText } from "../forms/input-text";
import { CCCField, Message, Severity } from "../forms/field/field";

@Component("ccc-discussion-search", {
  template: require("./discussionSearch.html").default,
  style: require("./discussionSearch.scss").default,
  viewModel: require("./discussionSearchVm"),
  observedAttributes: ["category-id", "items-per-page"],
})
export default class CCCDiscussionSearch extends CustomElement {
  private $keywords: CCCInputText;
  private $keywordsFld: CCCField;
  private errorMessage: Message;
  private keywordsValChanged: () => void;
  private searchDiscussions: (
    keywords: string,
    categoryId: number,
    page: number,
    limit: number
  ) => Promise<Array<Discussion>>;

  constructor() {
    super();

    this.errorMessage = {
      text: "Add keywords",
      severity: Severity.error,
    };
    setTimeout(() => {
      this.init();
    }, 1);
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    if (attr === "category-id") {
      const categoryId = Number(newValue);
      if (!isNaN(categoryId)) {
        this.categoryId = categoryId;
      } else {
        this.categoryId = null;
      }
    }
    if (attr === "items-per-page") {
      const itemsPerPage = Number(newValue);
      if (!isNaN(itemsPerPage)) {
        this.itemsPerPage = itemsPerPage;
      } else {
        this.itemsPerPage = null;
      }
    }
  }

  public set categoryId(value: number) {
    this.viewModel.categoryId = value;
  }

  public set itemsPerPage(value: number) {
    this.viewModel.itemsPerPage = value;
  }

  private init(): void {
    this.$keywords = <CCCInputText>this.shadowDom.querySelector("#keywordsFld");
    this.$keywordsFld = <CCCField>(
      this.$keywords.shadowDom.querySelector("ccc-field")
    );
    // Subscribe to keywords value.
    this.$keywords.subscribeToVal(true, (value: string) => {
      if (this.keywordsValChanged) {
        this.keywordsValChanged();
      }
      // Clean discussions list.
      const $discussionList = <CCCDiscussionList>(
        this.shadowDom.querySelector("ccc-discussion-list")
      );
      this.viewModel.page(1);
      $discussionList.discussions = [];
      this.viewModel.discussions([]);
      // Validate keywords field.
      if (value && value.length > 0) {
        this.$keywordsFld.message = null;
      } else {
        this.$keywordsFld.message = this.errorMessage;
      }
    });
  }

  private addSearchEvent($button: CCCButton, page = 0): void {
    if (this.searchDiscussions) {
      const $discussionList = <CCCDiscussionList>(
        this.shadowDom.querySelector("ccc-discussion-list")
      );
      // Add submit event.
      $button.addEventListener("ccc-button-click", () => {
        if (this.viewModel.categoryId) {
          const keywords = this.$keywords.getValue();
          if (keywords && keywords.length > 0) {
            // Disabled search button.
            $button.setAttribute("loading", "");
            // Do the search.
            this.searchDiscussions(
              this.$keywords.getValue(),
              this.viewModel.categoryId,
              this.viewModel.page() + page,
              this.viewModel.itemsPerPage
            )
              .then((discussions) => {
                $discussionList.discussions = discussions;
                this.viewModel.discussions(discussions);
                this.viewModel.page(this.viewModel.page() + page);
              })
              .catch(() => {
                $discussionList.discussions = [];
                this.viewModel.discussions([]);
              })
              .finally(() => {
                // Enable search button.
                $button.removeAttribute("loading");
              });
          } else {
            // Clean discussions list.
            this.viewModel.page(1);
            $discussionList.discussions = [];
            this.viewModel.discussions([]);
            const $keywordsFld = <CCCField>(
              this.$keywords.shadowDom.querySelector("ccc-field")
            );
            $keywordsFld.message = this.errorMessage;
          }
        }
      });
    }
  }

  public onKeywordsValChange(callback: () => void): void {
    this.keywordsValChanged = callback;
  }

  public onSearch(
    searchDiscussions: (
      keywords: string,
      categoryId: number,
      page: number,
      limit: number
    ) => Promise<Array<Discussion>>
  ): void {
    this.searchDiscussions = searchDiscussions;
    // Add button events.
    const $search = <CCCButton>this.shadowDom.querySelector("#searchBtn");
    this.addSearchEvent($search);
    const $previous = <CCCButton>this.shadowDom.querySelector("#previousBtn");
    this.addSearchEvent($previous, -1);
    const $next = <CCCButton>this.shadowDom.querySelector("#nextBtn");
    this.addSearchEvent($next, +1);
  }

  public onDiscussionLoad(
    getDiscussion: (discussionId: number) => Promise<Discussion>
  ): void {
    const $discussionList = <CCCDiscussionList>(
      this.shadowDom.querySelector("ccc-discussion-list")
    );
    $discussionList.onDiscussionLoad(getDiscussion);
  }
}
